const RequiredLabel: React.FC = () => (
  <span
    className="hidden md:inline-flex items-center justify-center shrink-0 text-[#F55B5B] bg-red-400/10 font-semibold uppercase"
    style={{
      height: '17px',
      padding: '0 5px',
      fontSize: '9px',
      lineHeight: '170%',
    }}
  >
    必須
  </span>
)

export default RequiredLabel
